<template>
  <button class="w-6 h-6 rounded transition-all duration-300 bg-red flex-center sm:opacity-0 group-hover:opacity-70 hover:!opacity-100" tabindex="0" @click.stop="$emit('delete')">
    <u-icon
      :name="COMMON_ICONS.deleteBin"
      class="w-5 h-5 transition-all absolute duration-300 text-white"
      aria-hidden="false"
    />
  </button>
</template>

<script setup>
  const emit = defineEmits(['delete']);
</script>
